import React from 'react';
import { arrayOf, object } from 'prop-types';
import styled from 'styled-components';
import shortid from 'shortid';

import ReasonItem from './ReasonItem';

const Container = styled.div`
  display: inline-block;

  @media(min-width: 1000px) {
    display: flex;
    flex-wrap: wrap;
    align-items: start;
    justify-content: center;
  }
`;

const ReasonList = React.memo(({ reasons }) => (
  <Container>
    {reasons.map(reason => <ReasonItem key={shortid.generate()} reason={reason} />)}
  </Container>
));

export default ReasonList;

ReasonList.propTypes = {
  reasons: arrayOf(object).isRequired,
};
